<div class="container-center">
  <h1 class="main-title">
    Your session has ended
    <br>
  </h1>
  <h2 class="title-accent">
      Thanks for joining and see you next time!
  </h2>
  <div class="logo-center">
    <img src="assets/img/rsm_logo.svg" alt="rsm-logo" width="240px">
  </div>
</div>
